/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const AppInfoR = t.interface({
  environment: t.string,

  name: t.string,

  version: t.string
});

// optional attributes
const AppInfoO = t.partial({
  dbConnection: t.string
});

export const AppInfo = t.intersection([AppInfoR, AppInfoO], "AppInfo");

export type AppInfo = t.TypeOf<typeof AppInfo>;
